import keyMirror from 'keymirror'

export const MIN_STRING = '            ' // space ascII code is 32
export const MAX_STRING = '龥' // the biggest code in all words

export const userStatusMapping = {
  true: 'active',
  false: 'inactive',
}

export const userStatusOptions = ['active', 'inactive']
export const userStatusAllOptions = ['all', 'active', 'inactive']

export const userTypeMapping = {
  501: 'userType.hklAdmin',
  521: 'userType.hklUser',
  401: 'userType.contractorAdmin',
  421: 'userType.contractorUser',
}

export const actionDict = {
  E: 'Updated',
  N: 'Added',
  D: 'Removed',
  A: 'Updated',
  PREVIOUS: 'Previous',
}

export const tenderStatus = keyMirror({
  DRAFT: null,
  ISSUED: null,
  WAPPR: null,
  APPR: null,
  REJECTED: null,
  REVIEW: null,
  READY: null,
  DECLINED: null,
  AWARDED: null,
  REGRETTED: null,
  CANCELLED: null,
})

export const tenderStatusAfterIssue = keyMirror({
  REVIEW: null,
  READY: null,
  AWARDED: null,
  REGRETTED: null,
})

export const addendumChangeType = {
  removed: 'D',
  added: 'N',
  updated: 'E',
  pending: {
    removed: 'D - P',
    added: 'N - P',
    updated: 'E - P',
  },
}

export const discountTypes = {
  PERCENTOFF: '% OFF',
  DOLLAROFF: 'HKD OFF',
}

export const projectStatus = keyMirror({
  DRAFT: null,
  ACTIVE: null,
  COMPLETED: null,
  CANCELLED: null,
  REVISD: null,
})

export const submissionStatus = keyMirror({
  DRAFT: null,
  OPEN: null,
  APPR: null,
  REJECTED: null,
})

export const completionType = keyMirror({
  FULL: null,
  PARTIAL: null,
  FINAL_PARTIAL: null,
  RETENTION: null, // for historical data only
  FINAL_PAYMENT: null,
  RETENTION_PAYMENT: null,
})

export const folderStatus = keyMirror({
  DRAFT: null,
  APPR: null,
  REJECTED: null,
})

export const vendorBidStatus = keyMirror({
  INVITED: null,
  DRAFT: null,
  SUBMITTED: null,
  QUERY: null,
  REOPEN: null,
  DECLINED: null,
})

export const bidStatusMap = {
  NO_SHOW: 'NO SHOW',
  INVITED: 'NO SHOW',
  DRAFT: 'NO SHOW',
  SUBMITTED: 'SUBMITTED',
  QUERY: 'QUERY',
  REOPEN: 'REOPEN',
  DECLINED: 'DECLINED',
}

export const bidStatusMapHealthCheck = {
  NO_SHOW: ' ',
  INVITED: ' ',
  DRAFT: ' ',
  SUBMITTED: 'REPLIED',
  QUERY: 'QUERY',
  REOPEN: 'REOPEN',
  DECLINED: 'REPLIED',
}

export const rateType = keyMirror({
  RANDOM: null,
  WORK_COMPLETED: null,
  RETENTION_RECEIVED: null,
  PROJECT_COMPLETED: null,
})

export const rateActionType = keyMirror({
  WORK_COMPLETED: null,
  RETENTION_RECEIVED: null,
})
export const queryStatus = keyMirror({
  DRAFT: null,
  ISSUED: null,
  SUBMITTED: null,
  NO_RESPONSE: null,
})

export const queryStatusMap = {
  ISSUED: 'Q-INVITED',
  SUBMITTED: 'Q-SUBMITTED',
  NO_RESPONSE: 'NO RESPONSE',
}

export const companyType = keyMirror({
  O: null,
  T: null,
  C: null,
  D: null,
  PC: null,
})

export const hotbTypes = keyMirror({
  HANDOVER: null,
  TAKEBACK: null,
})

export const hotbAttrTypes = {
  HANDOVER: 'handovers',
  TAKEBACK: 'takebacks',
}

export const hotbStatus = keyMirror({
  DRAFT: null,
  WAPPR: null,
  APPR: null,
  REJECTED: null,
  SCHEDULED: null,
  UNSIGNED: null,
  COMPLETED: null,
  CANCELLED: null,
})

export const tenancyStatus = keyMirror({
  ACTIVE: null,
  INACTIVE: null,
})

export const tenancyType = keyMirror({
  Office: null,
  Retail: null,
})

export const tenancyTypeMap = {
  Office: 'O',
  Retail: 'R',
}

export const TenancyLeaseTypes = {
  Office: ['TO', 'SO', 'LO', 'LP'],
  Retail: ['TS', 'SS', 'LS', 'LP'],
}

export const tenantProjectStatus = keyMirror({
  DRAFT: null,
  SUBMITTED: null,
  IN_PROGRESS: null,
  COMPLETED: null,
  CANCELLED: null,
  WITHDRAWN: null,
})

export const tenantProjectTypes = keyMirror({
  Fitout: null,
  Reinstatement: null,
})

export const typeSubsidiaryMap = {
  businessAsUsual: 'Business as usual',
  temporarySuspension: 'Closure / Temporary suspension',
}

export const hotbPremiseBuildingType = {
  asIs: 'As is',
  bareShell: 'Bare Shell',
  others: 'Others',
}

export const techCommentLineTypes = keyMirror({
  USER: null,
  GUIDELINE: null,
})

export const contractorStatus = {
  INVITED: 'Invited',
  NEW: 'New',
}

export const nonContractorStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}

export const DesignBatchStatus = keyMirror({
  DISAPPROVE: null,
  PROCEED_NO_FOLLOW_UP: null,
  PROCEED_CP_FOLLOW_UP: null,
})

export const GUIDELINE_STATUS = keyMirror({
  DRAFT: null,
  PUBLISHED: null,
})

export const ENGINEER_DASHBOARDS = keyMirror({
  CMS: null,
  TMS: null,
  WP: null,
})

export const ENGINEER_DASHBOARD_ROUTE = {
  CMS: 'home',
  TMS: 'engineerDashboard',
  WP: 'workPermitDashboard',
}

export const CREATOR_TYPES = keyMirror({
  TENANT: null,
  ENGINEER: null,
})

export const COMMON_TABLE_SELECT_FILTER_OPTION_ALL = 'all'
